import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class MarketParityParityManagerAddissueRoute extends Route {
  @service declare access: Services['access'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.access.can('market.paritymanager.manualissues.add')) {
      this.transition.redirectToTab(transition, 'market.parity.parity-manager');
    }
  }
}
